import { SegmentedControlOption } from "../../../components/SegmentedControl";
import { ReportMode } from "../types";

export const REPORTS_TITLE = "Reports";
export const REPORTS_SUBTITLE =
  "Generate a financial report for a period, then download it as a PDF.";

// The `/years` endpoints only cover active accounts, so deriving this bound from them would hide
// years the API (which checks every account) would happily report on; offer a fixed range instead.
export const REPORTS_MIN_TAX_YEAR = 2000;

export const REPORT_MODE_OPTIONS: SegmentedControlOption<ReportMode>[] = [
  { value: "custom", label: "Custom range" },
  { value: "taxYear", label: "Tax year" },
];

export const EMPTY_REPORT_TITLE = "Nothing to report for this period";
export const EMPTY_REPORT_DESCRIPTION =
  "There was no activity and no balances in the selected period, so there is nothing to put in a PDF. Try a different period.";

// Investment income copy is kept verbatim in sync with the API's PDF generator (PMA-249 parity).
export const INVESTMENT_INCOME_TITLE = "Investment income";
export const INVESTMENT_INCOME_BY_ACCOUNT_TITLE = "By account";
export const INVESTMENT_INCOME_BY_COUNTRY_TITLE = "Dividends by source country";
export const INVESTMENT_INCOME_EMPTY_NOTE =
  "No investment income in this period.";
export const MANUAL_ACCOUNTS_EXCLUDED_NOTE =
  "Income from manual investment accounts isn't included.";
export const INVESTMENT_INCOME_ACCOUNT_COLUMNS = [
  "Account",
  "Gross dividends",
  "Tax withheld",
  "Net dividends",
  "Gross interest",
  "Interest tax",
  "Net interest",
];
export const INVESTMENT_INCOME_COUNTRY_COLUMNS = [
  "Country",
  "Gross",
  "Tax withheld",
  "Net",
];
